// extracted by mini-css-extract-plugin
module.exports = {"base":"styles-m__base__32Ekl","mobile-hide":"styles-m__mobile-hide__Dug2p","line-separater":"styles-m__line-separater__2EO2O","skip-line":"styles-m__skip-line__1d4nm"};